<!--
 * @FilePath: /tongliao-nethall-h5-standard/src/views/Invoice/index.vue
-->
<template>
  <div class="invoice-page">
    <div class="invoice-header" v-if="isBind">
      <div class="invoice-select">
        <van-dropdown-menu active-color="#1677FF">
          <van-dropdown-item :title="accountScreen" ref="itemTwo">
            <div class="content">
              <van-radio-group v-model="result">
                <van-radio
                  v-for="(item, index) in topDatainfo"
                  :key="index"
                  :name="item.clientCode"
                  @click="getRadioValue(item)"
                >
                  <div class="right-txt">
                    <div class="first-li">
                      <span
                        >{{ item.clientName }} 户号: {{ item.clientCode }}</span
                      >
                    </div>
                    <div class="center-li">
                      <p>
                        <em
                          v-if="item.labelName && item.labelName.length > 0"
                          >{{ item.labelName }}</em
                        >
                        {{ item.clientAddress }}
                      </p>
                    </div>
                  </div>
                </van-radio>
                <!-- <div class="bottom-content">
                  <van-radio name="all" @click="getRadioValue('all')"
                    >全部账户</van-radio
                  >
                </div> -->
              </van-radio-group>
            </div>
          </van-dropdown-item>
          <!-- <van-dropdown-item :title="billYear" ref="yearTwo">
                <drop-down-selection
                  :currentValue="currentIndex"
                  :dataValArr="yearList"
                  @getSelectValue="getSelectValueInfo"
                />
              </van-dropdown-item> -->
        </van-dropdown-menu>
        <div class="invoice-setting">
          <span></span>
        </div>
      </div>
      <div class="month-range-bar">
        <div class="month-range-item" @click="showMonthPopup('start')">
          <span class="month-label">起始月份</span>
          <span class="month-value">{{ formatMonthDisplay(startMonth) }}<van-icon name="arrow-down" /></span>
        </div>
        <span class="month-range-sep">至</span>
        <div class="month-range-item" @click="showMonthPopup('end')">
          <span class="month-label">截止月份</span>
          <span class="month-value">{{ formatMonthDisplay(endMonth) }}<van-icon name="arrow-down" /></span>
        </div>
      </div>
      <van-tabs v-model="currentTab" class="invoice-tabs">
        <van-tab title="需要申请发票" name="apply" />
        <van-tab title="显示发票信息" name="invoiced" />
      </van-tabs>

      <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
        :disabled="true"
      >
        <van-list
          v-if="isDataFlag"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="selectRecLists"
        >
          <div class="invoice-content">
            <ul>
              <li
                v-for="(item, index) in currentList"
                :key="index"
                :class="item.isChecked ? 'invoice-li currentLi' : 'invoice-li'"
                @click="selectCurrentLi(index, 1)"
              >
                <div class="first-li">
                  <span>
                    {{ currentAccount.clientName }}「{{ item.clientCode }}-{{
                      currentAccount.clientAddress
                    }}」</span
                  >
                </div>
                <div class="name-li">
                  <span>发票金额：¥{{ item.printAmount }} </span>
                  <span class="pay-month">缴费月份:{{ item.payMonth }} </span>
                </div>
                <!-- <div class="name-li">
                  <span>
                    {{ currentAccount.clientName }}「{{ item.clientCode }}-{{
                      currentAccount.clientAddress
                    }}」</span
                  >
                </div> -->
                <div class="name-li">
                  <span
                    >已开：￥{{
                      item.printAmount ? item.printAmount : "0"
                    }}
                  </span>
                  <span class="pay-month"
                    >未开：￥{{
                      item.printAbleAmount
                        ? item.printAbleAmount
                        : "0"
                    }}</span
                  >
                </div>
                <div class="name-li">
                  <span>交易方式：{{ item.cciRealPayKindStr }} </span>
                </div>
                <div class="last-li">
                  <span>{{ item.invoiceTime }}开票</span>
                  <van-button
                    v-if="currentTab === 'apply'"
                    type="default"
                    size="small"
                    :disabled="item.invoiceApplying"
                    @click.stop="seeInvoice(item, index)"
                  >
                    {{ item.invoiceApplying ? '开票中' : '申请开票' }}
                  </van-button>
                  <van-button
                    v-if="currentTab === 'invoiced'"
                    type="default"
                    size="small"
                    @click.stop="seeInvoice(item, index)"
                  >
                    {{ item.pendingQuery ? '待查询' : '查询开票信息' }}
                  </van-button>
                </div>
                <p class="invoice-pending-tag" v-if="currentTab === 'invoiced' && item.pendingQuery">
                  待查询
                </p>
                <!-- <div class="triangle" v-if="+item.invoicePrintStatus == 2">
                  <span><van-icon name="tie-icon"/>已开</span>
                </div> -->
                <p class="invoived-success" v-if="invoicedLists.length > 0 && currentView === index">已开票信息：</p>
                <div class="" v-if="invoicedLists.length > 0 && currentView === index">
                  <van-button
                    v-for="list in invoicedLists"
                    :key="list.invoiceId"
                    type="info"
                    class="sms-button"
                    @click="toViewInvo(list, list.pdfUrl)"
                  >
                    {{ list.invoiceType == '1' ? '数电普票' : '数电专票' }}
                  </van-button>
                </div>
              </li>
            </ul>
            <!-- 底部选择总数 -->
            <div class="invoice-bottom" v-if="isClickMailBtnTwo">
              <div class="content">
                <em>已选{{ totalLi }}笔</em>
                <div class="btn">
                  <van-button
                    type="default"
                    size="small"
                    class="cancelBtn"
                    @click="cancelContent(1)"
                  >
                    取消
                  </van-button>
                  <van-button
                    type="default"
                    size="small"
                    class="invoiceBtn"
                    @click="showSendEmail"
                    :disabled="!totalLi > 0"
                  >
                    发送到邮箱
                  </van-button>
                </div>
              </div>
            </div>
          </div>
        </van-list>
        <no-Data v-else />
      </van-pull-refresh>
    </div>
    <no-data v-else />
    <invoice-popup :showFlag="show" @clickPopup="closePopup" />
    <van-popup
      v-model="showEmail"
      round
      :closeable="false"
      position="bottom"
      :style="{ height: '60%' }"
    >
      <div class="popup-content">
        <div class="title">
          <p>发送到邮箱</p>
        </div>
        <div class="content">
          <van-field
            v-model="email"
            placeholder="请输入邮箱"
            @input="getEamilList"
            clearable
          />
          <div class="email-list" v-if="showEmailList">
            <ul>
              <li
                v-for="(item, index) in listContent"
                :key="index"
                @click="getInputValue(item)"
              >
                <span>{{ item }}</span>
              </li>
            </ul>
          </div>
          <div class="btn">
            <van-button
              type="default"
              class="cancelBtn"
              @click="showEmail = false"
            >
              取消
            </van-button>
            <van-button type="info" class="sendBtn" @click="sendEmail"
              >发送</van-button
            >
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 月份选择弹窗 -->
    <van-popup
      position="bottom"
      v-model="showMonthPicker"
      round
    >
      <van-datetime-picker
        v-model="pickerDate"
        type="year-month"
        :title="monthPickerType === 'start' ? '选择起始月份' : '选择截止月份'"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="monthFormatter"
        @confirm="onMonthConfirm"
        @cancel="showMonthPicker = false"
      />
    </van-popup>
    <van-action-sheet
      v-model="showInvoiceAction"
      :actions="invoiceActions"
      cancel-text="取消"
      close-on-click-action
      @select="onInvoiceActionSelect"
    />
    <van-popup
      v-model="showInvoiceQr"
      round
      closeable
      position="bottom"
      :style="{ height: '68%' }"
    >
      <div class="invoice-qr-popup">
        <div class="invoice-qr-title">发票二维码</div>
        <img v-if="invoiceQrDataUrl" class="invoice-qr-image" :src="invoiceQrDataUrl" />
        <div class="invoice-qr-actions">
          <van-button type="info" block @click="copyInvoiceUrl">复制链接</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { isEmail } from "@/utils/validator";
import DropDownSelection from "@/components/dropDownSelection";
import InvoicePopup from "./module/invoicePopup";
import { formatTime } from "@/utils/tools";
import moment from "moment";
import store from "@/store";
import serverconfig from "@/api/server.config";
let HALL_WECHAT_API = serverconfig.API;
import {
  // selectNotInvoiced,
  selectReceivedRecords,
  queryPaidRecPage,
  queryIssueInfo,
  selectInvoiced,
  selectAccount,
  getInvoice,
  invoice,
  sendEmail,
  findRelevantEmail,
  sendInvoice,
  invoicePreview,
  getUrl,
  openInvoice,
  getTicket,
  fetchCurrentMonth,
} from "../../api/home";
import { selectHandUser } from "@/api/business";
import { Toast } from "vant";
import NoData from "@/components/noData.vue";
import { getBindList, sync } from '@/api/user.js';
import { debounce } from "lodash-es";
import QRCode from "qrcode";

const INVOICE_APPLY_HIDE_MINUTES = 5;
const INVOICE_APPLY_HIDE_KEY = "tongliao_invoice_apply_hide_map";
export default {
  name: "InvoiceList",
  components: {
    DropDownSelection,
    InvoicePopup,
    NoData,
  },
  data() {
    return {
      show: false,
      showEmail: false,
      currentMounth: "",
      checked: true,
      clientCode: this.$route.query.clientCode,
      invoicedConfigData: {},
      invoicedData: [], // 后台返回的缴费/开票记录全集
      applyInvoiceData: [],
      printedInvoiceData: [],
      notInvoicedData: [],
      topDatainfo: [], // 账单筛选
      yearList: [],
      accountList: [], // 账户筛选所选中的户号
      accountListAll: [], // 所有账户
      currentIndex: 0,
      totalLi: 0,
      accountScreen: "账户筛选",
      billYear: "年份",
      result: "all", // 账户筛选勾选状态--
      mailtxtOne: "批量开票",
      mailtxtTwo: "批量发送邮箱",
      currentTab: "apply",
      isClickMailBtnOne: false,
      isClickMailBtnTwo: false,
      email: "", // email集合
      listContent: [],
      showEmailList: true,
      // 分页
      refreshing: false,
      loading: false,
      requestLoading: false,
      finished: false,
      dataTotal: 0,
      currentPage: 1,
      size: 10,
      isBind: true,
      isDataFlag: true,
      isClickLeftFlag: true,
      isClickRightFlag: true,
      currentAccount: {},
      invoicedLists: [],
      currentView: undefined,
      showInvoiceAction: false,
      currentInvoiceItem: null,
      currentInvoiceIndex: undefined,
      invoiceActions: [
        { name: "显示发票二维码", key: "qrcode" },
        { name: "直接下载发票", key: "download" },
      ],
      showInvoiceQr: false,
      currentInvoiceUrl: "",
      invoiceQrDataUrl: "",
      applyingInvoiceRecIds: [],
      applyStateTimer: null,
      // 账目月份范围
      startMonth: "",
      endMonth: "",
      showMonthPicker: false,
      monthPickerType: "start", // 'start' | 'end'
      pickerDate: new Date(),
      minDate: new Date(new Date().getFullYear() - 3, 0, 1),
      maxDate: new Date(),
    };
  },
  mounted() {
    // this.getYear();
    this.initMonthRange().then(() => {
      this.init();
    });
  },
  beforeDestroy() {
    if (this.applyStateTimer) {
      clearTimeout(this.applyStateTimer);
      this.applyStateTimer = null;
    }
  },
  computed: {
    currentList() {
      return this.currentTab === "apply"
        ? this.applyInvoiceData
        : this.printedInvoiceData;
    },
  },
  watch: {
    currentTab() {
      this.isDataFlag = this.currentList.length > 0;
      this.totalLi = 0;
      this.isClickMailBtnTwo = false;
    },
  },
  methods: {
    async init() {
      this.topDatainfo = this.$store.state.user.bindInfo || [];
      if (this.$route.query && this.$route.query.clientCode) {
        this.accountList = [this.$route.query.clientCode];
        this.accountScreen = this.$route.query.clientCode;
        this.result = this.$route.query.clientCode;
        console.log('账户筛选--', this.accountScreen);
        this.selectRecLists();
        this.selectHandUser(this.$route.query.clientCode);
      }
      if (this.topDatainfo.length === 1) {
        this.getRadioValue(this.topDatainfo[0]);
      }
    },
    // 初始化账目月份范围（默认最近一年）
    async initMonthRange() {
      const res = await fetchCurrentMonth();
      const backendMonth =
        res && res.status === "complete" ? String(res.resultData || "") : "";
      const currentMonth = /^\d{6}$/.test(backendMonth)
        ? moment(backendMonth, "YYYYMM").format("YYYYMM")
        : moment().format("YYYYMM");
      this.endMonth = currentMonth;
      const startYear = parseInt(currentMonth.substring(0, 4)) - 1;
      const monthPart = currentMonth.substring(4, 6);
      this.startMonth = `${startYear}${monthPart}`;
    },
    // 显示月份选择弹窗
    showMonthPopup(type) {
      this.monthPickerType = type;
      // 设置当前选中的日期
      const yyyymm = type === 'start' ? this.startMonth : this.endMonth;
      if (yyyymm && yyyymm.length >= 6) {
        const y = parseInt(yyyymm.substring(0, 4));
        const m = parseInt(yyyymm.substring(4, 6)) - 1;
        this.pickerDate = new Date(y, m, 1);
      }
      this.showMonthPicker = true;
    },
    // 月份选择确认回调
    onMonthConfirm(date) {
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const yyyymm = month > 9 ? `${year}${month}` : `${year}0${month}`;
      if (this.monthPickerType === 'start') {
        this.startMonth = yyyymm;
      } else {
        this.endMonth = yyyymm;
      }
      this.showMonthPicker = false;
      // 重新查询
      this.currentPage = 1;
      this.resetInvoiceList();
      this.selectRecLists();
    },
    // 月份选择器格式化
    monthFormatter(type, val) {
      if (type === 'year') return `${val}年`;
      if (type === 'month') return `${val}月`;
      return val;
    },
    // 格式化月份显示 yyyymm -> yyyy年mm月
    formatMonthDisplay(yyyymm) {
      if (!yyyymm || yyyymm.length < 6) return '';
      let y = yyyymm.substring(0, 4);
      let m = parseInt(yyyymm.substring(4, 6));
      return `${y}年${m}月`;
    },
    
    resetInvoiceList() {
      this.invoicedData = [];
      this.applyInvoiceData = [];
      this.printedInvoiceData = [];
      this.invoicedLists = [];
      this.invoicedConfigData = {};
      this.currentView = undefined;
      this.isDataFlag = true;
      this.finished = false;
      this.loading = false;
    },
    getHiddenApplyMap() {
      try {
        const raw = window.localStorage.getItem(INVOICE_APPLY_HIDE_KEY);
        const parsed = raw ? JSON.parse(raw) : {};
        const now = Date.now();
        const cleaned = {};
        Object.keys(parsed || {}).forEach((key) => {
          const expireAt = Number(parsed[key]);
          if (expireAt && expireAt > now) {
            cleaned[key] = expireAt;
          }
        });
        if (JSON.stringify(parsed || {}) !== JSON.stringify(cleaned)) {
          window.localStorage.setItem(
            INVOICE_APPLY_HIDE_KEY,
            JSON.stringify(cleaned)
          );
        }
        return cleaned;
      } catch (e) {
        return {};
      }
    },
    getApplyHideKey(item) {
      if (!item) {
        return "";
      }
      return (
        item.recId ||
        [
          item.clientNo || item.clientCode || "",
          item.accountMonthly || item.payMonth || "",
          item.recDate || item.payTime || "",
          item.printAmount || item.printAbleAmount || "",
          item.invoiceTime || "",
        ]
          .filter(Boolean)
          .join("_")
      );
    },
    markApplyHidden(item) {
      const hideKey = this.getApplyHideKey(item);
      if (!hideKey) {
        return;
      }
      const hiddenMap = this.getHiddenApplyMap();
      hiddenMap[hideKey] =
        Date.now() + INVOICE_APPLY_HIDE_MINUTES * 60 * 1000;
      window.localStorage.setItem(
        INVOICE_APPLY_HIDE_KEY,
        JSON.stringify(hiddenMap)
      );
    },
    clearApplyHidden(item) {
      const hideKey = this.getApplyHideKey(item);
      if (!hideKey) {
        return;
      }
      const hiddenMap = this.getHiddenApplyMap();
      if (hiddenMap[hideKey]) {
        delete hiddenMap[hideKey];
        window.localStorage.setItem(
          INVOICE_APPLY_HIDE_KEY,
          JSON.stringify(hiddenMap)
        );
      }
    },
    isApplyHidden(item) {
      const hideKey = this.getApplyHideKey(item);
      if (!hideKey) {
        return false;
      }
      const hiddenMap = this.getHiddenApplyMap();
      return Boolean(hiddenMap[hideKey]);
    },
    isInvoiceReady(item) {
      return Boolean(
        item &&
          (+item.invoicePrintStatus === 2 ||
            item.pdfUrl ||
            item.invoiceId)
      );
    },
    removeApplyingRecId(recId) {
      if (!recId) {
        return;
      }
      this.applyingInvoiceRecIds = this.applyingInvoiceRecIds.filter(
        (id) => id !== recId
      );
    },
    promoteItemToReady(item, invoiceInfo) {
      if (!item) {
        return;
      }
      if (invoiceInfo && invoiceInfo.pdfUrl) {
        this.$set(item, "pdfUrl", invoiceInfo.pdfUrl);
      }
      if (invoiceInfo && invoiceInfo.invoiceId) {
        this.$set(item, "invoiceId", invoiceInfo.invoiceId);
      }
      this.$set(item, "invoicePrintStatus", 2);
      this.$set(item, "invoiceApplying", false);
      this.$set(item, "__localApplyHidden", false);
      this.clearApplyHidden(item);
      this.removeApplyingRecId(item.recId);
    },
    normalizeApplyLocalState() {
      this.invoicedData.forEach((item) => {
        const hiddenByTimer = this.isApplyHidden(item);
        const invoiceReady = this.isInvoiceReady(item);
        if (invoiceReady) {
          this.promoteItemToReady(item);
          return;
        }
        if (item.__localApplyHidden && !hiddenByTimer) {
          this.$set(item, "__localApplyHidden", false);
          this.$set(item, "invoiceApplying", false);
          this.removeApplyingRecId(item.recId);
        }
      });
    },
    scheduleApplyStateRefresh() {
      if (this.applyStateTimer) {
        clearTimeout(this.applyStateTimer);
        this.applyStateTimer = null;
      }
      const hiddenMap = this.getHiddenApplyMap();
      const expireTimes = Object.values(hiddenMap)
        .map((value) => Number(value))
        .filter((value) => value > Date.now());
      if (!expireTimes.length) {
        return;
      }
      const nextExpireAt = Math.min(...expireTimes);
      const delay = Math.max(nextExpireAt - Date.now() + 100, 100);
      this.applyStateTimer = setTimeout(() => {
        this.applyStateTimer = null;
        this.normalizeApplyLocalState();
        this.refreshCurrentListState();
      }, delay);
    },
    hideApplyItemLocally(item) {
      if (item.recId && !this.applyingInvoiceRecIds.includes(item.recId)) {
        this.applyingInvoiceRecIds.push(item.recId);
      }
      this.markApplyHidden(item);
      this.$set(item, "invoiceApplying", true);
      this.$set(item, "__localApplyHidden", true);
      this.refreshCurrentListState();
    },
    refreshCurrentListState() {
      this.normalizeApplyLocalState();
      this.invoicedData.forEach((item) => {
        if (this.applyingInvoiceRecIds.includes(item.recId)) {
          this.$set(item, "invoiceApplying", true);
        }
      });
      const hiddenApplyData = this.invoicedData
        .filter(
          (item) =>
            +item.invoicePrintStatus !== 2 &&
            (this.isApplyHidden(item) || item.__localApplyHidden)
        )
        .map((item) => ({
          ...item,
          pendingQuery: true,
        }));
      this.applyInvoiceData = this.invoicedData.filter(
        (item) =>
          +item.invoicePrintStatus !== 2 &&
          !this.isApplyHidden(item) &&
          !item.__localApplyHidden
      );
      this.printedInvoiceData = hiddenApplyData.concat(
        this.invoicedData
          .filter((item) => +item.invoicePrintStatus === 2)
          .map((item) => ({
            ...item,
            pendingQuery: false,
          }))
      );
      this.invoicedLists = new Array(this.invoicedData.length).fill([]);
      this.isDataFlag = this.currentList.length > 0;
      this.scheduleApplyStateRefresh();
    },
    getListFromResult(resultData) {
      if (Array.isArray(resultData)) {
        return resultData;
      }
      if (!resultData || typeof resultData !== "object") {
        return [];
      }
      return (
        resultData.records ||
        resultData.list ||
        resultData.rows ||
        resultData.data ||
        []
      );
    },
    mergeInvoiceRecords(list) {
      const previousMap = new Map();
      this.invoicedData.forEach((item) => {
        previousMap.set(this.getApplyHideKey(item), item);
      });
      const recordMap = new Map();
      this.invoicedData.concat(list).forEach((item) => {
        const key = this.getApplyHideKey(item);
        const prev = previousMap.get(key);
        if (prev) {
          if (prev.invoiceApplying && !item.invoiceApplying) {
            item.invoiceApplying = true;
          }
          if (prev.__localApplyHidden && !item.__localApplyHidden) {
            item.__localApplyHidden = true;
          }
        }
        recordMap.set(
          key ||
            `${item.clientNo || item.clientCode || ""}_${item.accountMonthly || item.payMonth || ""}_${item.recDate || item.payTime || ""}_${item.printAmount || item.printAbleAmount || ""}`,
          item
        );
      });
      this.invoicedData = Array.from(recordMap.values());
    },
    // 缴费/开票记录数据
    async selectRecLists() {
      if (this.requestLoading) {
        return;
      }
      if (!this.accountScreen || this.accountScreen == "账户筛选") {
        this.loading = false;
        this.finished = true;
        return;
        // Toast.fail("请选择账户筛选");
      }
      this.loading = true;
      this.requestLoading = true;
      let param = {
        clientNo: this.accountScreen,
        startMonth: this.startMonth,
        endMonth: this.endMonth,
        pageNum: this.currentPage,
        pageSize: this.size,
      };
      try {
        const response = await queryPaidRecPage(param);
        const status = response && response.status;
        const resultData = response && response.resultData;
        if (status === "complete") {
          const list = this.getListFromResult(resultData);
          if (list.length > 0) {
            this.dataTotal = resultData.total || resultData.count || list.length;
            this.mergeInvoiceRecords(list);
            this.refreshCurrentListState();
            this.currentPage++;
            this.finished = this.invoicedData.length >= this.dataTotal;
          } else if (this.currentPage === 1) {
            this.resetInvoiceList();
            this.finished = true;
            this.isDataFlag = false;
          } else {
            this.finished = true;
            this.isDataFlag = this.currentList.length > 0;
          }
        } else {
          this.finished = true;
        }
      } catch (e) {
        this.finished = true;
        this.isDataFlag = this.currentList.length > 0;
      } finally {
        this.requestLoading = false;
        this.loading = false;
      }
    },
    // 发票数据
    async selectInvoiced() {
      if (!this.accountScreen || this.accountScreen == "账户筛选") {
        this.loading = false;
        this.finished = true;
        return Toast.fail("请选择账户筛选");
      }
      let param = {
        clientCode: this.accountScreen,
        invoicePrintStatus: 1,
      };
      const { status, resultData } = await queryIssueInfo(param);
      if (status === "complete") {
        this.invoicedConfigData = resultData;
      } else {
        this.finished = true;
      }
      this.loading = false;
    },
    // 账户筛选数据
    async selectAccount() {
      const { status, resultData } = await selectAccount();
      // const { status, resultData } = await selectAccount();
      if (status === "complete") {
        this.topDatainfo = resultData;
        let tempAccount = [];
        let indexList = [];
        resultData &&
          resultData.map((item, index) => {
            tempAccount.push(item.clientCode);
            if (item.selected) {
              indexList.push(index);
            }
          });
        this.accountListAll = tempAccount;
      }
    },
    // tab切换
    handleClick(name, title) {
      // 切换的时候，默认账户筛选 全部勾选状态
      // let indexList = [];
      // this.result = 'all';
      // this.accountScreen = '账户筛选';
      // this.accountList = [];
      // this.billYear = '年份';
      // this.currentIndex = 0; // 年份 默认选择第一个0
      this.currentPage = 1; // 分页
      this.totalLi = 0; // 总条数
      this.mailtxtOne = "批量开票";
      this.mailtxtTwo = "批量发送邮箱";
      this.isClickMailBtnOne = false;
      this.isClickLeftFlag = true;
      this.isClickMailBtnTwo = false;
      if (name === "1") {
        this.invoicedData = [];
        this.selectInvoiced();
      } else {
        this.notInvoicedData = [];
        this.selectNotInvoiced();
      }
      this.currentTab = name;
      // this.finished = false;
    },
    // 我要开票 + 批量发送邮箱
    getMail(msg) {
      if (msg === 0) {
        this.mailtxtOne =
          this.mailtxtOne === "批量开票" ? "请选择要开发票的账单" : "批量开票";
        this.isClickMailBtnOne = !this.isClickMailBtnOne;
      } else {
        this.mailtxtTwo =
          this.mailtxtTwo === "批量发送邮箱"
            ? "选择要发送到邮箱发票"
            : "批量发送邮箱";
        this.isClickMailBtnTwo = !this.isClickMailBtnTwo;
      }
    },
    // 选择多条开票
    selectCurrentLi(index, key) {
      if (key === 0 && this.isClickMailBtnOne) {
        this.notInvoicedData[index].isChecked = !this.notInvoicedData[index]
          .isChecked;
        let i = 0;
        this.notInvoicedData.map((item) => {
          if (item.isChecked) {
            i++;
          }
        });
        this.isClickLeftFlag = false;
        // 已勾选的条数
        this.totalLi = i;
        if (this.totalLi === 0) {
          this.mailtxtOne = "批量开票";
          this.isClickMailBtnOne = !this.isClickMailBtnOne;
          this.isClickLeftFlag = true;
        }
      } else if (key === 1 && this.isClickMailBtnTwo) {
        this.invoicedData[index].isChecked = !this.invoicedData[index]
          .isChecked;
        let i = 0;
        this.invoicedData.map((item) => {
          if (item.isChecked) {
            i++;
          }
        });
        this.isClickRightFlag = false;
        // 已勾选的条数
        this.totalLi = i;
        if (this.totalLi === 0) {
          this.mailtxtTwo = "批量发送邮箱";
          this.isClickMailBtnTwo = !this.isClickMailBtnTwo;
          this.isClickRightFlag = true;
        }
      }
      // this.currentTab = name;
    },
    // 已缴费账单详情
    // gotoPage(item, tabIndex) {
    //   console.log('跳转页面--', item);
    //   this.$router.push({
    //     name: 'FeeDetails',
    //     path: '/QueryPay/FeeDetails',
    //     query: {
    //       name: 'invoice',
    //       tabIndex,
    //       ...item
    //     }
    //   });
    // },
    // 账户筛选---确定
    sureContent() {
      this.$refs.itemOne.toggle();
      this.accountScreen = "账户筛选";

      let tempAccount = [];
      let NotInvoiceWuserNoList = [];
      this.topDatainfo.map((item, index) => {
        if (item.selected) {
          tempAccount.push(item.clientCode);
          NotInvoiceWuserNoList.push(item.clientCode);
        }
      });

      // 如果全部选中：则显示 账户筛选
      if (this.topDatainfo.some((item) => item.selected)) {
        this.accountScreen = NotInvoiceWuserNoList.join(",");
      }

      this.accountList = tempAccount.length === 0 ? [""] : tempAccount;
      this.currentPage = 1;
    },
    // 单选按钮事件
    getRadioValue(value) {
      if (value !== "all") {
        this.currentAccount = value;
        this.accountScreen = value.clientCode;
        this.accountList = [];
        this.accountList.push(value.clientCode);
      } else if (value === "all") {
        this.accountScreen = "全部账户";
        this.accountList = [];
      }
      // 有条件的筛选
      this.currentPage = 1;
      this.totalLi = 0;
      this.resetInvoiceList();
      this.selectRecLists();
      // this.selectSync();
      this.selectHandUser(this.currentAccount.clientCode);
      this.$refs.itemTwo.toggle();
    },
    // async selectSync() {
    //   const res = await asyncApi(this.accountScreen);
    //   console.log(res);
    // },
    // 取消事件
    cancelContent(key) {
      if (key === 0) {
        this.notInvoicedData.map((item) => {
          item.isChecked = false;
        });
        this.totalLi = 0;
        this.mailtxtOne = "批量开票";
        this.isClickMailBtnOne = !this.isClickMailBtnOne;
        this.isClickLeftFlag = true;
      } else {
        this.invoicedData.map((item) => {
          item.isChecked = false;
        });
        this.totalLi = 0;
        this.mailtxtTwo = "批量发送邮箱";
        this.isClickMailBtnTwo = !this.isClickMailBtnTwo;
        this.isClickRightFlag = true;
      }
    },
    // AA未开发票---我要开票【每个卡片的按钮】
    async getInvoiceInfo(e, index) {
      e.stopPropagation();
      this.notInvoicedData[index].buttonContent = "开票中...";
      const arg = [
        {
          custRealId: this.notInvoicedData[index].custRealId,
          clientCode: this.notInvoicedData[index].clientCode,
          electronicInvoicesId: this.notInvoicedData[index]
            .electronicInvoicesId,
        },
      ];
      const { status, resultData } = await invoice(arg);
      if (status === "complete") {
        this.show = true;
      }
    },
    // 未开发票---批量开票
    async getAllInvoice() {
      let argArray = [];
      this.notInvoicedData &&
        this.notInvoicedData.map((item) => {
          if (item.isChecked) {
            let obj = {
              billType: "5",
              cciBatch: item.cciBatch,
              clientCode: item.clientCode,
              issuanceType: "0",
            };
            argArray.push(obj);
          }
        });
      const { status } = await invoicePreview(argArray);
      if (status === "complete") {
        // 批量开票成功后，显示发票成功页面
        this.show = true;
        this.isClickLeftFlag = true;
      }
    },
    // 发票弹框--关闭成功页面
    closePopup(value) {
      this.notInvoicedData = [];
      this.currentPage = 1;
      this.resetInvoiceList();
      // this.selectNotInvoiced();
      this.selectRecLists();
      this.show = false;
    },
    async selectHandUser(clientCode) {
      const { status, resultData } = await selectHandUser(
        clientCode
      );
      if (status === "complete" && resultData) {
        this.currentAccount = {...resultData[0], ...this.currentAccount};
      }
    },
    downInvoice(item) {
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = getUrl(item.pdfUrl);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    toViewInvo(item, invoiceUrl) {
        this.$router.push({ path: '/Invoice/invoiceView', query: { pdfParam:item, invoiceUrl: invoiceUrl} });
    },
    async onInvoiceActionSelect(action) {
      if (!this.currentInvoiceItem) {
        return;
      }
      const invoice = await this.getInvoiceFileInfo(
        this.currentInvoiceItem,
        this.currentInvoiceIndex
      );
      if (!invoice) {
        return;
      }
      const invoiceUrl = this.normalizeInvoiceUrl(invoice.pdfUrl, invoice);
      if (!invoiceUrl) {
        Toast("发票链接为空");
        return;
      }
      if (action.key === "download") {
        this.openInvoiceUrl(invoiceUrl);
        return;
      }
      if (action.key === "qrcode") {
        this.currentInvoiceUrl = invoiceUrl;
        this.invoiceQrDataUrl = await QRCode.toDataURL(invoiceUrl, {
          width: 220,
          margin: 1,
        });
        this.showInvoiceQr = true;
      }
    },
    async getInvoiceFileInfo(item, index) {
      if (item.pdfUrl) {
        return item;
      }
      const params = {
        cciBatch: item.recId || "",
        clientCode: item.clientNo || "",
      };
      const { status, resultData } = await getTicket(params);
      if (status === "complete" && resultData && resultData.length > 0) {
        const invoiceInfo = resultData[0];
        if (invoiceInfo && invoiceInfo.pdfUrl) {
          this.$set(item, "pdfUrl", invoiceInfo.pdfUrl);
          this.$set(item, "invoiceId", invoiceInfo.invoiceId);
          this.promoteItemToReady(item, invoiceInfo);
          this.refreshCurrentListState();
        }
        this.$set(this.invoicedLists, index, resultData);
        return invoiceInfo;
      }
      Toast("未查询到发票信息");
      return null;
    },
    normalizeInvoiceUrl(url, invoiceInfo) {
      if (url) {
        return getUrl(url);
      }
      if (invoiceInfo && invoiceInfo.invoiceId) {
        const token = this.getInvoiceToken();
        const invoiceUrl = `/main/bcsApi/web/invoice/invMain/getFile/${invoiceInfo.invoiceId}?token=${encodeURIComponent(token)}`;
        return `${window.location.origin}${invoiceUrl}`;
      }
      return "";
    },
    getInvoiceToken() {
      const userInfo = store.getters.userInfo || {};
      return userInfo.token || "";
    },
    openInvoiceUrl(url) {
      if (!url) {
        Toast("发票链接为空");
        return;
      }
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      link.download = "";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async copyInvoiceUrl() {
      if (!this.currentInvoiceUrl) {
        Toast("发票链接为空");
        return;
      }
      let copied = false;
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(this.currentInvoiceUrl);
          copied = true;
        }
      } catch (e) {
        copied = false;
      }
      if (!copied) {
        const input = document.createElement("textarea");
        input.value = this.currentInvoiceUrl;
        input.setAttribute("readonly", "readonly");
        input.style.position = "fixed";
        input.style.top = "0";
        input.style.left = "0";
        input.style.width = "1px";
        input.style.height = "1px";
        input.style.opacity = "0";
        input.style.fontSize = "16px";
        document.body.appendChild(input);
        input.focus();
        input.select();
        input.setSelectionRange(0, input.value.length);
        copied = document.execCommand("copy");
        document.body.removeChild(input);
      }
      if (copied) {
        Toast("复制成功");
      } else {
        Toast("复制失败，请长按链接手动复制");
      }
    },
    async seeInvoice(item, index) {
      if (+item.invoicePrintStatus == 2 || this.isInvoiceReady(item)) {
        this.currentInvoiceItem = item;
        this.currentInvoiceIndex = index;
        this.showInvoiceAction = true;
      } else if (item.pendingQuery) {
        const invoice = await this.getInvoiceFileInfo(item, index);
        if (invoice) {
          this.currentInvoiceItem = item;
          this.currentInvoiceIndex = index;
          this.showInvoiceAction = true;
        } else {
          Toast("电子发票已申请成功，请稍后在这里查询");
        }
      } else if (item.invoiceApplying) {
        Toast("电子发票已申请成功，开票中请稍后查询");
      } else {
        this.submit(item, 1);
      }
    },
    submit: debounce(async function(item, invoiceId) {
      let userInfo = store.getters.userInfo;
      let params = {
        clientCode: item.clientNo || "",
        recId: item.recId || "",
        clientName: this.currentAccount.clientName || "",
        accountMonthly: item.accountMonthly || "",
        // invoiceType: this.currentAccount.clientType,
        // address: this.currentAccount.clientAddress || "",
        // customerNo: this.currentAccount.customerNo,
        // isDefault: true,
        // phone: this.currentAccount.clientPhone || "",
        // cciBatch:  item.recId || "",
        // userId: userInfo.userId,
        // vatBank: item.vatBank || "",
        // vatBankAccount: item.vatBankAccount || "",
        // vatCode: item.vatCode || "",
        // issuanceType: "1",
        // invoiceId: invoiceId,
      };
      let data = await openInvoice(params);
      console.log(data, "data");
      const errorMessage =
        (data && (data.errorMessage || data.message || data.resultMessage)) ||
        "";
      const shouldHideAsPending =
        data &&
        (data.status === "complete" ||
          errorMessage.indexOf("可开票应收记录为空") > -1);
      if (shouldHideAsPending) {
        this.hideApplyItemLocally(item);
        this.show = true;
      } else {
        Toast(errorMessage || "申请开票失败");
      }
    }, 1000),
    async selectTiket(item, type, index) {
      this.invoicedLists = [];
      const params = {
        cciBatch: item.recId || "",
        clientCode: item.clientNo || "",
      };
      const { status, resultData } = await getTicket(params);
      if (status === "complete") {
        if (resultData && resultData.length > 0) {
          if(type == 1) { 
            this.submit(item, resultData[0].invoiceId)
          } else {
            this.invoicedLists = resultData;
          }
        }
      }
    },
    // 获取邮箱列表
    getEamilList(event) {
      this.listContent = [];
      if (event.indexOf("@qq") >= 0) {
        this.listContent.push(
          `${event}@163.com`,
          `${event}@126.com`,
          `${event}@sohu.com`
        );
      } else if (event.indexOf("@163") >= 0) {
        this.listContent.push(
          `${event}@qq.com`,
          `${event}@126.com`,
          `${event}@sohu.com`
        );
      } else if (event.indexOf("@126") >= 0) {
        this.listContent.push(
          `${event}@qq.com`,
          `${event}@163.com`,
          `${event}@sohu.com`
        );
      } else if (event.indexOf("@sohu") >= 0) {
        this.listContent.push(
          `${event}@qq.com`,
          `${event}@163.com`,
          `${event}@126.com`
        );
      } else if (event.indexOf("@") >= 0) {
        this.listContent = [];
      } else {
        this.listContent.push(
          `${event}@qq.com`,
          `${event}@163.com`,
          `${event}@126.com`,
          `${event}@sohu.com`
        );
      }
      this.showEmailList = true;
    },
    // 点击列表获取当前选中的邮箱
    getInputValue(value) {
      this.email = value;
      this.showEmailList = false;
    },
    // 已开发票 - 批量发送邮箱
    async showSendEmail() {
      // 获取邮箱值内容
      let clientCodeList = [];
      this.currentList.map((item) => {
        if (item.isChecked) {
          clientCodeList.push(item.clientCode);
        }
      });
      let arg = { clientCodeList };

      const { status, resultData } = await findRelevantEmail(arg);
      if (status === "complete") {
        this.email = resultData;
        this.listContent = [];
        this.showEmail = true;
        this.isClickRightFlag = true;
      }
    },
    // 邮箱校验
    validatorEmail(val) {
      return isEmail(val);
    },
    // 邮箱确定按钮事件
    async sendEmail() {
      if (this.validatorEmail(this.email)) {
        let argArray = [];
        this.currentList &&
          this.currentList.map((item) => {
            if (item.isChecked) {
              let data = {
                invoiceId: item.invoiceId,
                mail: this.email,
                phone: "13456565656",
                type: 1,
              };
              argArray.push(data);
            }
          });
        const { status, resultData, errorMessage } = await sendInvoice(
          argArray
        );
        if (status === "complete") {
          // 成功后---清除勾选状态：
          this.totalLi = 0;
          this.mailtxtTwo = "批量发送邮箱";
          this.isClickMailBtnTwo = !this.isClickMailBtnTwo;

          this.currentList &&
            this.currentList.map((item) => {
              item.isChecked = false;
            });
          this.showEmail = false;
          Toast({
            message: "发送成功！",
            icon: "passed",
          });
        } else {
          Toast({
            message: errorMessage,
            icon: "close",
          });
        }
      } else {
        Toast("请输入正确的邮箱地址！");
      }
    },
    // 年份
    getSelectValueInfo(value, index) {
      this.billYear = value;
      this.currentIndex = index;
      this.$forceUpdate();

      this.currentPage = 1;
      this.totalLi = 0;
      if (this.currentTab === "0") {
        this.notInvoicedData = [];
        this.selectNotInvoiced();
        this.$refs.yearOne.toggle();
      } else {
        this.invoicedData = [];
        this.selectInvoiced();
        this.$refs.yearTwo.toggle();
      }
    },
    // 选择年份 - 获取年份(12个月份)
    getYear() {
      const date = new Date();
      const year = date.getFullYear();
      for (let i = year - 11; i <= year; i++) {
        this.yearList.push({
          name: i + "年",
        });
      }
      this.yearList.reverse();
    },
    // 下拉刷新
    onRefresh() {
      this.currentPage = 1;
      this.resetInvoiceList();
      this.selectRecLists();
      this.loading = false;
    },
  },
};
</script>

<style lang="less" scoped>
.month-range-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 16px;
  background: #ffffff;
  margin-bottom: 10px;
  .month-range-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    padding: 8px 0;
    background: #f5f7fa;
    border-radius: 6px;
    cursor: pointer;
    .month-label {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.45);
      margin-bottom: 2px;
    }
    .month-value {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      font-weight: 500;
      .van-icon {
        margin-left: 4px;
        font-size: 10px;
      }
    }
  }
  .month-range-sep {
    margin: 0 12px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.45);
  }
}
.invoice-page {
  width: 100%;
  .invoice-qr-popup {
    padding: 24px 20px 20px;
    text-align: center;
    .invoice-qr-title {
      font-size: 18px;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
      margin-bottom: 18px;
    }
    .invoice-qr-image {
      width: 220px;
      height: 220px;
      display: block;
      margin: 0 auto 16px;
    }
    .invoice-qr-actions {
      display: grid;
      grid-template-columns: 1fr;
      gap: 10px;
    }
  }
  .invoice-header {
    background: #ffffff;
    text-align: center;
    height: 60px;
    /deep/.van-tabs {
      margin: 0 auto;
    }
    /deep/ .van-tab {
      padding-top: 10px;
    }
    /deep/.van-tab--active {
      color: #1677ff;
    }
  }
  .invoice-select {
    display: flex;
    justify-content: space-between;
    padding: 16px;
    font-size: 14px;
    background: #ffffff;
    margin-bottom: 10px;
    .invoice-setting {
      font-family: PingFangSC-Regular;
      font-size: 12px;
      letter-spacing: 0;
      color: #4466ad;
      span:first-child {
        padding-right: 10px;
      }
      span.current {
        color: rgba(0, 0, 0, 0.25);
      }
    }
    /deep/.van-dropdown-menu__title {
      padding: 0px;
      width: 120px;
      text-align: center;
      color: rgba(0, 0, 0, 0.65);
    }
    /deep/.van-dropdown-menu__bar {
      height: auto;
      background: transparent;
      box-shadow: none;
    }
    /deep/.van-dropdown-menu__title::after {
      border-color: transparent transparent rgba(0, 0, 0, 0.65)
        rgba(0, 0, 0, 0.65);
    }
    /deep/.van-dropdown-menu__item {
      background: #fff;
      margin-right: 10px;
    }
    // 下拉年份
    .content {
      padding-top: 5px;
      padding-bottom: 10px;
      // li标签
      ul {
        li {
          width: calc(100% / 3 - 17px);
          display: inline-block;
          text-align: center;
          border: 1px solid #eeeeee;
          border-radius: 3px;
          margin-right: 15px;
          margin-top: 15px;
          position: relative;
          overflow: hidden;
          span {
            display: inline-block;
            height: 32px;
            line-height: 32px;
            font-family: PingFangSC-Medium;
            font-size: 14px;
            color: #6e6e6e;
            text-align: center;
          }
          // 选中样式
          .triangle {
            width: 30px;
            height: 30px;
            background: #1677ff;
            position: absolute;
            bottom: -15px;
            right: -15px;
            transform: rotate(45deg);
            i {
              position: absolute;
              bottom: 5px;
              right: 5px;
              display: block;
              width: 18px;
              text-align: center;
              color: #ffffff;
              transform: rotate(-25deg);
            }
          }
          .triangle::after {
            display: inline-block;
            content: "";
            width: 30px;
            height: 35px;
            background: #ffffff;
            transform: rotate(-45deg);
            position: absolute;
            bottom: 18px;
            right: 0px;
            z-index: 20;
          }
        }
        .currentSpan {
          color: #0a79ec;
          background: #cde4ff;
        }
      }
      // 账单筛选
      .right-txt {
        .first-li {
          margin-left: 16px;
          margin-right: 16px;
          margin-bottom: 4px;
          display: flex;
          justify-content: space-between;
          span {
            font-family: PingFangSC-Medium;
            font-size: 16px;
            color: rgba(0, 0, 0, 0.85);
            letter-spacing: 0;
            line-height: 20px;
            font-weight: 600;
          }
          .pay-month {
            position: relative;
            right: 0px;
          }
        }
        .center-li {
          margin-left: 14px;
          em {
            font-size: 12px;
            padding: 1px 5px;
            font-style: normal;
            font-family: PingFangSC-Regular;
            color: #637fb7;
            letter-spacing: 0;
            line-height: 16px;
            background: #ecf1fe;
            border-radius: 2px;
          }
          p {
            margin: 0px;
            font-size: 14px;
            font-family: PingFangSC-Regular;
            color: rgba(0, 0, 0, 0.65);
            letter-spacing: 0;
            line-height: 22px;
            text-align: left;
          }
        }
      }
      .van-radio {
        margin-top: 15px;
      }
      .van-radio-group {
        margin-left: 16px;
        margin-right: 16px;
        margin-bottom: 15px;
      }
      .bottom-content {
        position: relative;
        // border-top: 1px solid rgba(0,0,0,0.08);
        display: flex;
        justify-content: space-between;
        padding-top: 15px;
        // padding-left: 16px;
        // padding-right: 16px;
        // padding-bottom: 16px;
        .sureBtn {
          width: 79px;
          border-radius: 4px;
          font-size: 14px;
        }
      }
      .bottom-content::after {
        position: absolute;
        box-sizing: border-box;
        content: " ";
        pointer-events: none;
        right: 0px;
        top: 0;
        left: 0px;
        border-top: 1px solid #ebedf0;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
      }
    }
  }
  .invoice-content {
    background: #f3f3f3;
    margin-top: 10px;
    margin-bottom: 40px;
    ul {
      margin: 0px 16px;
      .invoice-li {
        background-color: #ffffff;
        border-radius: 8px;
        margin-bottom: 10px;
        position: relative; // 选中样式
        overflow: hidden;
        border: 1px solid transparent;
        .first-li {
          display: flex;
          justify-content: space-between;
          padding: 12px 16px 6px 16px;
          span {
            font-family: PingFangSC-Medium;
            font-size: 16px;
            color: rgba(0, 0, 0, 0.85);
            letter-spacing: 0;
            line-height: 20px;
            font-weight: 600;
          }
        }
        .name-li {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          margin: 0 16px;
          font-size: 14px;
          > span {
            margin-bottom: 6px;
          }

          .pay-month {
            position: relative;
            right: 0px;
          }
        }
        .name-li-first {
          padding-right: 8px;
        }
        .center-li {
          margin-left: 16px;
          margin-right: 16px;
          em {
            font-size: 12px;
            padding: 1px 5px;
            font-style: normal;
            font-family: PingFangSC-Regular;
            color: #637fb7;
            letter-spacing: 0;
            line-height: 16px;
            background: #ecf1fe;
            border-radius: 2px;
          }
          p {
            margin: 0px;
            padding-top: 8px;
            font-size: 14px;
            font-family: PingFangSC-Regular;
            color: rgba(0, 0, 0, 0.65);
            letter-spacing: 0;
            line-height: 22px;
            text-align: left;
          }
        }
        .last-li {
          display: flex;
          justify-content: space-between;
          margin-left: 16px;
          margin-right: 16px;
          padding-bottom: 11px;
          span {
            font-size: 12px;
            line-height: 32px;
            font-family: PingFangSC-Regular;
            color: rgba(0, 0, 0, 0.45);
            letter-spacing: 0;
          }
          .van-button {
            border-radius: 8px;
            padding-left: 8px;
            padding-right: 8px;
            span {
              font-family: PingFangSC-Regular;
              font-size: 12px;
              color: #4285f4;
              letter-spacing: 0;
              text-align: center;
              line-height: 24px;
            }
          }
          .van-button--default {
            border: 1px solid #4285f4;
          }
        }
      }
      // 选中样式
      .currentLi {
        border: 1px solid #1c74fa;
      }
      .triangle {
        width: 50px;
        height: 50px;
        background: #1677ff;
        position: absolute;
        top: -25px;
        right: -28px;
        transform: rotate(45deg);
        span {
          position: absolute;
          bottom: -4px;
          display: block;
          width: 50px;
          text-align: center;
          color: #ffffff;
          transform: rotate(-25deg);
        }
      }
    }
  }
  .invoice-bottom {
    height: 56px;
    line-height: 56px;
    background: #ffffff;
    // padding: 0px 16px;
    padding: 0px;
    position: fixed;
    bottom: 0px;
    width: 100%;
    .content {
      // display: inline-block;
      em {
        font-family: PingFangSC-Regular;
        font-style: normal;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
        letter-spacing: 0;
        float: left;
        padding-left: 18px;
      }
      .btn {
        float: right;
        margin-right: 30px;
        .cancelBtn {
          margin-right: 16px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          background: #f6f6f6;
          color: #4285f4;
          letter-spacing: 0;
          text-align: center;
          line-height: 24px;
          width: 80px;
          border-radius: 4px;
        }
        .invoiceBtn {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #ffffff;
          background: #4285f4;
          letter-spacing: 0;
          text-align: center;
          line-height: 24px;
          border-radius: 4px;
        }
      }
    }
  }
  .popup-content {
    .title {
      border-bottom: 1px solid #eeeeee;
      padding-top: 12px;
      padding-bottom: 12px;
      p {
        font-family: PingFangSC-Medium;
        font-size: 18px;
        color: #333333;
        text-align: center;
        line-height: 26px;
        margin: 0px;
      }
    }
    .content {
      /deep/.van-field__control {
        height: 45px;
        background-color: #f9f8f8;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
        letter-spacing: 0;
        text-indent: 1em;
      }
      .btn {
        margin-left: 16px;
        margin-right: 16px;
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        .cancelBtn {
          width: 125px;
          height: 44px;
          border-radius: 4px;
          background: #f6f6f6;
          color: #4285f4;
        }
        .sendBtn {
          width: 125px;
          height: 44px;
          border-radius: 4px;
        }
      }
      .email-list {
        margin: 16px;
        max-height: 200px;
        // overflow-y: scroll;
        ul {
          li {
            height: 28px;
            line-height: 28px;
          }
        }
      }
    }
  }

  .sms-button {
    height: 36px;
    padding: 0 4px;
    font-size: 16px;
    margin-right: 10px;
    width: 100px;
    border-radius: 6px;
    margin-bottom: 20px;
  }
  .invoived-success {
    text-align: left;
    padding-top: 10px;
    margin: 8px 16px;
    border-top: 1px solid #eee;
  }
  .invoice-pending-tag {
    margin: 0 16px 10px;
    text-align: left;
    color: #fa8c16;
    font-size: 12px;
    line-height: 18px;
  }
}
</style>
